'use strict'

units = [
  { size: 1000*1000*1000*1000, decimals: 1, format: '##.FormatFileSize.TB'}
  { size: 1000*1000*1000, decimals: 1, format: '##.FormatFileSize.GB'}
  { size: 1000*1000, decimals: 1, format: '##.FormatFileSize.MB'}
  { size: 1000, decimals: 1, format: '##.FormatFileSize.KB'}
  { size: 0, decimals: 0, format: '##.FormatFileSize.bytes'}
]

# Returns a friendly file size for the given amount of bytes
export formatFileSize = (translator, formatter) ->
  (bytes) ->
    for unit in units
      if bytes >= unit.size
        bytes /= unit.size if unit.size
        return formatter (translator unit.format), { COUNT: bytes.toFixed(unit.decimals) }

    return ''
